
export const allProductsHandle = 'all'
